(function() {
	'use strict';

	angular
		.module('pwc.controllers')
		.controller('WinePurchaseDialogController', WinePurchaseDialogController);

	WinePurchaseDialogController.$inject = ['$scope', '$window', '$mdDialog', 'WinePurchase', 'userPouch', 'wine', 'lodash', '$log', 'transaction', 'combinedHistoryIndex', 'WineRepository', '$filter', 'MessageService', 'persistOnSave', '$timeout', '$rootScope', 'ENV'];

	function WinePurchaseDialogController($scope, $window, $mdDialog, WinePurchase, userPouch, wine, lodash, $log, transaction, combinedHistoryIndex, WineRepository, $filter, MessageService, persistOnSave, $timeout, $rootScope, ENV){

		/* jshint validthis: true */
		var self = this;

		self.wine = wine;

		self.onOrder = false;

		self.purchase = null;

		self.searchText = null;

		self.sources = [];

		self.isEdit = false;

		self.persistOnSave = persistOnSave;

		self.save = save;
		self.closeDialog = closeDialog;
		self.querySearch = querySearch;
		self.setSource = setSource;
		self.localeSymbol = ENV.LOCALE_SYMBOL;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){
			if (lodash.isNotEmptyOrNull(transaction)){
				// angular datepicker wants js Date
				// this is required because mdDateLocaleProvider is for typed in data
				$timeout(function(){
					transaction.date = lodash.isNotEmptyOrNull(transaction.date) ? $window.moment(transaction.date).toDate() : null;
					transaction.due = lodash.isNotEmptyOrNull(transaction.due) ? $window.moment(transaction.due).toDate() : null;
					transaction.arrived = lodash.isNotEmptyOrNull(transaction.arrived) ? $window.moment(transaction.arrived).toDate() : null;
					self.purchase = transaction;
				});

				self.isEdit = true;
			} else {
				self.purchase = new WinePurchase();
				// default to in cellar
                self.purchase.status = 'Arrived';
			}

			WineRepository.uniqueAcquisitionSources().then(function(sources){
				self.sources = sources;
			});

			// if cellar doesn't yet have any bottles, set the value as the price when it changes
			$scope.$watch(function() {
				return lodash.get(self.purchase, 'price');
			}, function(newValue, oldValue) {
				if (lodash.get(self.wine, 'cellar.qty') === 0){
					self.wine.cellar.value = lodash.parseInt(newValue);
				}
			});
		}

		function save(){

			$log.debug('Saving transaction...');

			self.purchase.qty = lodash.parseInt(self.purchase.qty);

			self.wine.upsertCombinedHistoryItem(self.purchase, combinedHistoryIndex);

			if (persistOnSave){
				return _persist();
			} else {
				closeDialog();
				$rootScope.$emit('WineTransactionAddedButNotSaved');
				_showPostSaveToast();
			}
		}

		function _showPostSaveToast(){
			var msg = "Purchase " + (self.isEdit ? 'Updated' : 'Added') + ". Don't forget to save when done editing.";

			return MessageService.showToast(msg, 5000);
		}

		function _persist(){

			// prep dates for saving to CouchDB
			self.purchase.date = $window.moment(self.purchase.date).toISOString();

			if (lodash.isNotEmptyOrNull(self.purchase.due)){
				self.purchase.due = $window.moment(self.purchase.due).toISOString();
			}

			if (lodash.isNotEmptyOrNull(self.purchase.arrived)){
				self.purchase.arrived = $window.moment(self.purchase.arrived).toISOString();
			}

			userPouch
				.save(self.wine)
				.then(function(){
					return MessageService.showToast('Purchase saved!', 5000);
				})
				.then(closeDialog)
				.catch(function(err){
					$log.error('Error saving wine.', err);
					MessageService.showToast('Unable to save. Please contact support if problem persists', 5000);
				});
		}

		function closeDialog(){
			return $mdDialog.hide();
		}

		/**
		 * Search for states... use $timeout to simulate
		 * remote dataservice call.
		 */
		function querySearch(query) {
			return lodash.isNotEmptyOrNull(query) ? filterSources(query) : self.sources;
		}

		/**
		 * Create filter function for a query string
		 */
		function filterSources(query) {

			var words = query.split(' ');

			var filteredSources = self.sources;

			lodash.each(words, function(word) {
				filteredSources = $filter('filter')(filteredSources, word);
			});

			return filteredSources;
		}

		function setSource(source){
			self.purchase.source = source;
		}
	}

})();